import urls from '@/legacy/config/env';
import { fetchRequest } from '@/legacy/services';
import { Option } from '@/legacy/types';

export const fetchCompaniesOptions = async (): Promise<Option[]> => {
	const response = await fetchRequest<Option[]>({
		url: urls.formOptions.companies,
		method: 'GET',
	});

	return response.data;
};
